var map = {
	"./access_pass_record.svg": "B/iZ",
	"./agent_management.svg": "cCQM",
	"./area_management.svg": "PH5N",
	"./back.svg": "RN8c",
	"./basic_setting.svg": "YFjH",
	"./berth_management.svg": "s6Uy",
	"./camera_management.svg": "ybj6",
	"./certificate.svg": "Rnjg",
	"./device.svg": "k6Cd",
	"./discharge_head.svg": "j5cD",
	"./display.svg": "ebzu",
	"./distributor.svg": "CtzV",
	"./distributor_device.svg": "pOun",
	"./distributor_user.svg": "MeCl",
	"./driver_management.svg": "o+2a",
	"./exam_training.svg": "60Be",
	"./examination_record.svg": "7u+H",
	"./eye.svg": "4wdf",
	"./file_download.svg": "4h89",
	"./function.svg": "wB4m",
	"./home.svg": "U9Ws",
	"./identifier_record.svg": "yqHn",
	"./judge.svg": "TxYQ",
	"./label_management.svg": "4RjF",
	"./language.svg": "+Dip",
	"./load_ship_task.svg": "fq31",
	"./load_unload_ship_task.svg": "RPgy",
	"./material_management.svg": "3B+i",
	"./multiple.svg": "ZPTm",
	"./ng-form-setting.svg": "aRsF",
	"./notice.svg": "MqGM",
	"./notice_management.svg": "TZuS",
	"./online_examination.svg": "KCCU",
	"./operating_record.svg": "Q7Py",
	"./orangnization.svg": "S5kW",
	"./param_setting.svg": "K+ij",
	"./parking_management.svg": "vlCq",
	"./password1.svg": "wmqS",
	"./pipe_flex_management.svg": "GUJg",
	"./pipe_hard_management.svg": "ED3R",
	"./pipeline_management.svg": "r2SN",
	"./pipeline_wash.svg": "6Hw9",
	"./purging_task.svg": "OyRZ",
	"./question_bank_management.svg": "1KNB",
	"./receiving_safety.svg": "MIhS",
	"./right.svg": "9iyg",
	"./role.svg": "cqqK",
	"./scheduling.svg": "4aZa",
	"./scheduling_task_management.svg": "pctj",
	"./ship_management.svg": "AHpD",
	"./single.svg": "9D4L",
	"./staff_management.svg": "3ISE",
	"./staff_permission.svg": "/e+9",
	"./sys_dictionary.svg": "W4Wm",
	"./system_management.svg": "4nWl",
	"./tank_management.svg": "t4D7",
	"./tank_pour_task.svg": "zMfd",
	"./task_management.svg": "VE35",
	"./team_management.svg": "L8t/",
	"./training_records.svg": "GZY2",
	"./unload_ship_task.svg": "Xa8Z",
	"./unloading.svg": "orG9",
	"./unloading_equipment_management.svg": "ZU7O",
	"./unloading_management.svg": "s/eQ",
	"./unloading_monitoring.svg": "2luk",
	"./unloading_platform_management.svg": "O4Uj",
	"./user.svg": "VdD3",
	"./user1.svg": "Ebwp",
	"./user_permissions.svg": "Wyab",
	"./vehicle_management.svg": "lffu",
	"./video.svg": "3JNx",
	"./video_management.svg": "Zt1M",
	"./work_task.svg": "1oWJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 39